<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<p class="ch-tit"><b>Baby Bib</b></p>
<p class="ch-au">Abbey Lane Quilts</p>
</div>
<div class="chap1">
<p class="noindentx"><b>FINISHED SIZE:</b> Approx. 8˝ × 11˝</p>
</div>
<p class="noindentno"><i>You can never have too many bibs for a baby. Grab some cute scraps for this quick and easy project and make a bib to match every outfit</i>.</p>
<p class="image"><img alt="" src="images/pg3.jpg"/></p>
<div class="grey">
<p class="noindents"><span class="grey1"><b>ABBEY LANE QUILTS</b></span> is a pattern design company founded in 2008 by the team of Marcea Owen and Janice Liljenquist. Marcea is an entrepreneur and writer with a background in art and interior design. Janice is an accomplished quilting teacher and longarm quilter. Abbey Lane Quilts is based in Oviedo, Florida.</p>
<p class="image"><img alt="" src="images/pg3-2.jpg"/></p>
<p class="noindents"><span class="grey1"><b>WEBSITE:</b></span> <a href="http://abbeylanequilts.com" target="_blank">abbeylanequilts.com</a></p>
<p class="line1"> </p>
<p class="noindents">This project originally appeared in <i>Baby Times</i>, by Abbey Lane Quilts, available from Stash Books.</p>
<p class="image"><img alt="" src="images/pg3-3.jpg"/></p>
</div>
<p class="ma"><b>Materials and Cutting</b></p>
<p class="noindentsa"><i>Prewash all fabrics and canvas before cutting</i>.</p>
<p class="image"><img alt="" src="images/pg3-1.jpg"/></p>
<p class="h1">Instructions</p>
<p class="noindentsa"><span class="ro"><b>1.</b></span> Sew Fabric A to Fabric B along the 5½˝ side. Press seam. This will be Row 1.</p>
<p class="noindents"><span class="ro"><b>2.</b></span> Sew Fabric C to Fabric D along the 4½˝ side. Press seam. This will be Row 2.</p>
<p class="noindents"><span class="ro"><b>3.</b></span> Sew Rows 1 and 2 together. Press seam.</p>
<p class="noindents"><span class="ro"><b>4.</b></span> Sew Fabric E to the bottom of the unit. Press seam.</p>
<p class="image"><img alt="" src="images/pg4.jpg"/></p>
<p class="noindents"><span class="ro"><b>5.</b></span> Make 2 copies of the Baby Bib pattern. Cut out the 2 pieces, flip one over, and tape them together along the dotted lines.</p>
<p class="noindents"><span class="ro"><b>6.</b></span> Layer the 3 fabric pieces in the following order:</p>
<p class="bull"><span class="ro">•</span> Canvas square on the bottom</p>
<p class="bull"><span class="ro">•</span> Backing square (right side up) in the middle</p>
<p class="bull"><span class="ro">•</span> Pieced top (wrong side up) on the top</p>
<p class="image"><img alt="" src="images/pg4-1.jpg"/></p>
<p class="noindents"><span class="ro"><b>7.</b></span> Place the bib template on top of the stack and trace the outline with chalk or an erasable marker.</p>
<p class="image"><img alt="" src="images/pg4-2.jpg"/></p>
<p class="noindents"><span class="ro"><b>8.</b></span> Pin all 3 layers together. Cut out the bib.</p>
<p class="noindents"><span class="ro"><b>9.</b></span> Sew around the entire bib, leaving a 2˝ opening at the bottom. Clip the curves. Turn right side out and press.</p>
<p class="noindents"><span class="ro"><b>10.</b></span> Turn the opening in and pin closed. Topstitch around the entire bib. The top stitching will close the opening.</p>
<p class="noindents"><span class="ro"><b>11.</b></span> Sew one side of the hook-and-loop dot to each tab. One side will be on the front of the tab and the other will be on the back of the other tab.</p>
<p class="noindentx"><img alt="" class="mi" src="images/tip.jpg"/> It is helpful to sew the hook side of the dot on the back of the top tab and the soft loop side on the front of the bottom tab. This way the baby’s hair is not so easily caught in the hook side of the dot.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?2de8d85d